import { forwardRef } from 'react';
import { cx } from '@eti/styles';
import { Card } from '@etg/wings';
import { bindCoreComponents, renderCoreComponents, sortCoreComponents } from '../utils/product-layout-utils';
import ProductCardContextProvider from '../context/ProductCardContext';
import Illustration from './illustration/Illustration';
import Header from './header/Header';
import Body from './body/Body';
import ReadMore from './read-more/ReadMore';
import ButtonContainer from './cta-components/ButtonContainer';
import { productWrapperStyles, standardGrid } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
const productCardCoreComponents = {
  Illustration,
  Header,
  Body,
  ReadMore,
  Cta: ButtonContainer
};
const ProductLayout = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    customGrid,
    productData,
    className,
    coreComponentsRenderConfig
  } = _ref;
  const {
    productName,
    isHighlighted,
    productId
  } = productData;
  const sortedCoreComponents = sortCoreComponents(ProductLayout, coreComponentsRenderConfig);
  return /*#__PURE__*/_jsx(ProductCardContextProvider, {
    productData: productData,
    children: /*#__PURE__*/_jsx(Card, {
      className: cx(productWrapperStyles(isHighlighted), className, customGrid !== null && customGrid !== void 0 ? customGrid : standardGrid),
      "data-offer-rate": productId,
      "data-testid": `${productName}-container`,
      ref: ref,
      children: renderCoreComponents(sortedCoreComponents, children)
    })
  });
});
export default bindCoreComponents(ProductLayout, productCardCoreComponents);
//# sourceMappingURL=ProductLayout.js.map